(() => {
  function init(root) {
    if (root.dataset.crReady) return;
    root.dataset.crReady = 'true';
    const variants = JSON.parse(root.querySelector('[data-cr-variants]').textContent);
    const labels = JSON.parse(root.querySelector('[data-cr-labels]').textContent);
    const form = root.querySelector('.cr-product-form');
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:root.dataset.currency || 'USD'}).format(cents / 100);
    let variant = variants.find(v => String(v.id) === form.querySelector('[name=id]').value) || variants[0];
    let quantity = variant.min || 1;
    let index = 0;
    let busy = false;
    let checkoutBusy = false;
    let added = null;
    const slides = [...root.querySelectorAll('[data-slide]')];
    const gallery = root.querySelector('.cr-gallery');
    const paymentDialog = root.querySelector('[data-payment-dialog]');
    const imageDialog = root.querySelector('[data-image-dialog]');
    const status = root.querySelector('[data-form-status]');
    const sticky = root.querySelector('[data-sticky]');
    const cleanQuantity = value => {
      const min = variant.min || 1, step = variant.step || 1, max = variant.max || Number.MAX_SAFE_INTEGER;
      const n = Number.isFinite(Number(value)) && value !== '' ? Math.trunc(Number(value)) : min;
      const clamped = Math.max(min, Math.min(max, n));
      return min + Math.floor((clamped - min) / step) * step;
    };
    const showImage = n => {
      index = (n + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      root.querySelectorAll('[data-gallery-index]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.galleryIndex) === index)));
      root.querySelector('[data-gallery-caption]').textContent = labels.captions[index];
      root.querySelector('[data-gallery-count]').textContent = `${index + 1} / ${slides.length}`;
    };
    const preview = count => slides[count === 3 ? 2 : 1].querySelector('.cr-pack').cloneNode(true);
    const render = () => {
      const saving = variant.compare > variant.price ? Math.round((variant.compare - variant.price) / variant.compare * 100) : 0;
      form.querySelector('[name=id]').value = String(variant.id);
      root.querySelectorAll('[data-qty]').forEach(input => { input.value = quantity; input.min = variant.min || 1; input.step = variant.step || 1; if (variant.max) input.max = variant.max; else input.removeAttribute('max'); });
      root.querySelectorAll('[data-qty-change]').forEach(button => { button.disabled = busy || (Number(button.dataset.qtyChange) < 0 ? quantity <= (variant.min || 1) : !!variant.max && quantity >= variant.max); });
      root.querySelectorAll('[data-total]').forEach(el => el.textContent = money(variant.price * quantity));
      root.querySelectorAll('[data-total-compare]').forEach(el => { el.hidden = !saving; el.textContent = saving ? money(variant.compare * quantity) : ''; });
      root.querySelectorAll('[data-saving]').forEach(el => { el.hidden = !saving; el.textContent = saving ? `${labels.save} ${saving}%` : ''; });
      root.querySelectorAll('[name=cr-pack-choice]').forEach(input => { input.checked = String(variant.id) === input.value; input.disabled = busy || !variants.find(v => String(v.id) === input.value).available; });
      root.querySelectorAll('[data-variant-select]').forEach(input => { input.value = String(variant.id); input.disabled = busy; });
      root.querySelectorAll('[data-selected-title]').forEach(el => el.textContent = `${variant.title} · ${variant.count} × 100g`);
      root.querySelectorAll('[data-selected-pack]').forEach(el => el.replaceChildren(preview(variant.count)));
      root.querySelectorAll('[data-add]').forEach(button => { button.disabled = busy || !variant.available; button.querySelector('span').textContent = busy ? labels.adding : variant.available ? labels.add : labels.sold; });
    };
    const select = value => {
      const next = variants.find(v => String(v.id) === String(value));
      if (!next || busy) return;
      variant = next;
      quantity = cleanQuantity(quantity);
      render();
      showImage(variant.count === 3 ? 2 : 1);
      const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
    };
    root.addEventListener('change', event => {
      if (event.target.matches('[name=cr-pack-choice],[data-variant-select]')) select(event.target.value);
    });
    root.querySelectorAll('[data-qty]').forEach(input => {
      input.addEventListener('input', () => {
        if (input.value === '' || !Number.isInteger(Number(input.value)) || Number(input.value) < (variant.min || 1)) return;
        quantity = cleanQuantity(input.value); render();
      });
      input.addEventListener('blur', () => { quantity = cleanQuantity(input.value); render(); });
      input.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); quantity = cleanQuantity(input.value); render(); } });
    });
    root.querySelectorAll('[data-qty-change]').forEach(button => button.addEventListener('click', () => {
      const input = button.closest('.cr-quantity').querySelector('[data-qty]');
      quantity = cleanQuantity(cleanQuantity(input.value) + Number(button.dataset.qtyChange) * (variant.step || 1)); render();
    }));
    root.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => showImage(index + Number(button.dataset.galleryStep))));
    root.querySelectorAll('[data-gallery-index]').forEach(button => button.addEventListener('click', () => showImage(Number(button.dataset.galleryIndex))));
    let down = null;
    gallery.addEventListener('pointerdown', event => { if (event.target.closest('button')) return; down = {x:event.clientX,y:event.clientY,type:event.pointerType}; });
    gallery.addEventListener('pointerup', event => {
      if (!down || event.target.closest('button')) { down = null; return; }
      const dx = event.clientX - down.x, dy = event.clientY - down.y;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) showImage(index + (dx < 0 ? 1 : -1));
      else if (Math.abs(dx) < 10 && Math.abs(dy) < 10) {
        const box = gallery.getBoundingClientRect(), part = (event.clientX - box.left) / box.width;
        if (down.type === 'touch' && part < .22) showImage(index - 1);
        else if (down.type === 'touch' && part > .78) showImage(index + 1);
        else openZoom();
      }
      down = null;
    });
    gallery.addEventListener('pointercancel', () => { down = null; });
    let scale = 1;
    function openZoom() {
      scale = 1;
      const clone = slides[index].cloneNode(true); clone.hidden = false;
      imageDialog.querySelector('.cr-image-zoom-content').replaceChildren(clone);
      imageDialog.showModal();
    }
    root.querySelector('[data-zoom-open]').addEventListener('click', openZoom);
    imageDialog.querySelectorAll('[data-image-scale]').forEach(button => button.addEventListener('click', () => {
      scale = Math.max(.75, Math.min(3, scale + Number(button.dataset.imageScale)));
      imageDialog.querySelector('.cr-slide').style.transform = `scale(${scale})`;
    }));
    imageDialog.addEventListener('keydown', event => { if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); showImage(index + (event.key === 'ArrowLeft' ? -1 : 1)); openZoom(); } });
    async function add(event) {
      event?.preventDefault();
      if (busy || !variant.available) return;
      quantity = cleanQuantity(form.querySelector('[name=quantity]').value); busy = true; status.textContent = ''; render();
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity}]})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || labels.error);
        added = {variant:{...variant},quantity,item:result.items?.[0]};
        root.querySelector('[data-added-total]').textContent = money(variant.price * quantity);
        root.querySelector('[data-modal-summary]').textContent = `${variant.title} · ${quantity} ${quantity === 1 ? 'pack' : 'packs'} · ${variant.count * quantity} × 100g`;
        root.querySelector('[data-checkout-status]').textContent = '';
        paymentDialog.showModal();
        document.dispatchEvent(new CustomEvent('cr:cart-added',{detail:added}));
      } catch (error) { status.textContent = error.message || labels.error; }
      finally { busy = false; render(); }
    }
    form.addEventListener('submit', add);
    sticky.querySelector('[data-add]').addEventListener('click', add);
    const unlockCheckout = () => { checkoutBusy = false; root.querySelectorAll('[data-checkout-status]').forEach(el=>el.textContent=''); refreshPayments(); };
    function refreshPayments() {
      root.querySelectorAll('[data-pay]').forEach(button => {
        const modal = button.closest('[data-payment-context]').dataset.paymentContext === 'modal';
        const api = button.dataset.pay === 'paypal' ? (modal ? 'itcCartDrawerPayPal' : 'itcProdPagePayPal') : button.dataset.pay === 'card' ? (modal ? 'itcCartDrawerCheckout' : 'itcProdPageCheckout') : '';
        button.disabled = checkoutBusy || !api || typeof window[api] !== 'function';
      });
    }
    root.querySelectorAll('[data-pay]').forEach(button => button.addEventListener('click', event => {
      if (button.disabled || checkoutBusy) return;
      const modal = button.closest('[data-payment-context]').dataset.paymentContext === 'modal';
      const api = button.dataset.pay === 'paypal' ? (modal ? 'itcCartDrawerPayPal' : 'itcProdPagePayPal') : (modal ? 'itcCartDrawerCheckout' : 'itcProdPageCheckout');
      if (modal && !added) return;
      quantity = cleanQuantity(form.querySelector('[name=quantity]').value); render();
      checkoutBusy = true; refreshPayments();
      const out = modal ? root.querySelector('[data-checkout-status]') : status; out.textContent = labels.processing;
      try {
        const result = window[api](event);
        if (result && typeof result.catch === 'function') result.catch(() => { unlockCheckout(); out.textContent = labels.checkout_error; });
      } catch { unlockCheckout(); out.textContent = labels.checkout_error; }
    }));
    window.addEventListener('pageshow', unlockCheckout);
    window.addEventListener('focus', () => { if (checkoutBusy) unlockCheckout(); });
    let checks = 0; const poll = setInterval(() => { refreshPayments(); if (++checks >= 30) clearInterval(poll); }, 1000);
    if (window.ResizeObserver) new ResizeObserver(() => document.documentElement.style.setProperty('--cr-sticky-height', `${sticky.getBoundingClientRect().height + 16}px`)).observe(sticky);
    render(); showImage(new URL(location.href).searchParams.has('variant') ? (variant.count === 3 ? 2 : 1) : 0); refreshPayments();
  }
  function initFooter() {
    const data = document.querySelector('[data-cr-share]');
    if (!data || data.dataset.ready) return;
    data.dataset.ready = 'true';
    const settings = JSON.parse(data.textContent);
    const dialog = document.querySelector('[data-share-dialog]');
    const input = dialog.querySelector('input'); input.value = settings.url;
    async function copy(status) {
      try { if (!navigator.clipboard?.writeText) throw new Error('No clipboard API'); await navigator.clipboard.writeText(settings.url); status.textContent = settings.copied; }
      catch { status.textContent = settings.manual; input.focus(); input.select(); }
    }
    document.querySelector('[data-copy-product]').addEventListener('click', () => { dialog.querySelector('[data-share-instruction]').textContent = settings.manual; dialog.querySelector('[data-platform-open]').hidden = true; dialog.showModal(); });
    dialog.querySelector('[data-share-copy]').addEventListener('click', () => copy(dialog.querySelector('[data-share-status]')));
    document.querySelectorAll('[data-platform]').forEach(button => button.addEventListener('click', () => {
      dialog.querySelector('[data-share-instruction]').textContent = settings[button.dataset.platform];
      const link = dialog.querySelector('[data-platform-open]'); link.href = button.dataset.platformUrl; link.hidden = false;
      dialog.querySelector('[data-share-status]').textContent = ''; dialog.showModal();
    }));
  }
  const boot = () => {
    document.querySelectorAll('[data-cr-product]').forEach(init); initFooter();
    document.querySelectorAll('[data-dialog-close]').forEach(button => { if (button.dataset.ready) return; button.dataset.ready='1'; button.addEventListener('click', () => button.closest('dialog').close()); });
    document.querySelectorAll('dialog').forEach(dialog => { if (dialog.dataset.crOutside) return; dialog.dataset.crOutside='1'; dialog.addEventListener('click', event => { if (event.target === dialog) { const b=dialog.getBoundingClientRect(); if (event.clientX < b.left || event.clientX > b.right || event.clientY < b.top || event.clientY > b.bottom) dialog.close(); } }); });
    document.querySelectorAll('.cr-videos video').forEach(video => { if (video.dataset.crSound) return; video.dataset.crSound='1'; video.muted=false; video.volume=1; video.addEventListener('play',()=>document.querySelectorAll('.cr-videos video').forEach(other=>{if(other!==video)other.pause();})); });
  };
  document.addEventListener('shopify:section:load', boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
